import { render, staticRenderFns } from "./SchoolDepartmentSurveyReport.vue?vue&type=template&id=c23a4a56"
import script from "./SchoolDepartmentSurveyReport.vue?vue&type=script&lang=js"
export * from "./SchoolDepartmentSurveyReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports